// Intentionally replaces the generated `attachSupabaseAuth`:
// also forwards the active staff profile id so the server can enforce
// per-role permissions (see src/lib/api/staff-guard.ts).
import { createMiddleware } from "@tanstack/react-start";
import { supabase } from "./client";
import { ACTIVE_STAFF_KEY } from "@/lib/active-staff";


export const attachSupabaseAuthWithStaff = createMiddleware({ type: "function" }).client(
  async ({ next }) => {
    let token: string | undefined;
    const { data } = await supabase.auth.getSession();
    token = data.session?.access_token;
    let activeStaffId: string | null = null;
    try {
      if (typeof window !== "undefined") {
        activeStaffId = window.localStorage.getItem(ACTIVE_STAFF_KEY);
      }
    } catch {
      activeStaffId = null;
    }
    if (!token) {
      // This middleware only attaches credentials. Public server functions (such
      // as the PIN-link lookup) must work before a session exists; protected
      // functions enforce authentication with `requireSupabaseAuth` server-side.
      return next({ headers: {} });
    }

    const headers: Record<string, string> = { Authorization: `Bearer ${token}` };
    if (activeStaffId) headers["x-active-staff-id"] = activeStaffId;
    return next({ headers });
  },
);

